module.exports = __webpack_public_path__ + "static/media/upload_more.6de8b4f8.svg";